<div class="header">
  <button
    type="button"
    class="al-page-back al-relief-icon al-relief-icon--large al-icon--chevron-left"
    (click)="onBack()"
    [attr.aria-label]="'buttons.back' | translate"
    [nbTooltip]="'buttons.back' | translate"
    nbTooltipPlacement="right"
  ><span class="al-relief-glyph" aria-hidden="true"></span></button>
  <h2>{{ "pages.dozent.exerciseEditor.title" | translate }}</h2>
  <div class="header-actions">
    <button
      nbButton
      status="primary"
      (click)="onSave()"
      [disabled]="!title || isSaving"
      [nbSpinner]="isSaving"
    >
      <nb-icon icon="save-outline"></nb-icon>
      {{ "buttons.save" | translate }}
    </button>
  </div>
</div>

<app-page-loader *ngIf="isLoading"></app-page-loader>

<!-- Aus dem Creator veröffentlicht (Ziel „KI-Tutor“): Bearbeiten gehört in
     den Creator (Q95/P4), die nächste Veröffentlichung ersetzt diesen Stand. -->
<div class="creator-note" *ngIf="!isLoading && exercise?.creator_item_id">
  <p class="page-hint">
    {{ "pages.dozent.exerciseEditor.creatorNote" | translate: { version: exercise?.creator_version_no } }}
  </p>
  <button nbButton status="primary" size="small" (click)="onEditInCreator()">
    <nb-icon icon="edit-outline"></nb-icon>
    {{ "pages.dozent.exercises.editInCreator" | translate }}
  </button>
</div>

<div class="editor-content" *ngIf="!isLoading && exercise">
  <!-- Basic Info -->
  <nb-card>
    <nb-card-header>
      {{ "pages.dozent.exerciseEditor.basicInfo" | translate }}
    </nb-card-header>
    <nb-card-body>
      <div class="form-row">
        <label>{{ "input.name.label" | translate }}</label>
        <input nbInput fullWidth [(ngModel)]="title" />
      </div>
      <div class="form-row-group">
        <div class="form-row">
          <label>{{ "pages.dozent.exercises.type" | translate }}</label>
          <nb-select [(selected)]="exerciseType" fullWidth>
            <nb-option *ngFor="let type of exerciseTypes" [value]="type.value">
              {{ type.label }}
            </nb-option>
          </nb-select>
        </div>
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.difficulty" | translate }}</label>
          <nb-select [(selected)]="difficultyLevel" fullWidth>
            <nb-option *ngFor="let d of difficultyLevels" [value]="d.value">
              {{ d.labelKey | translate }}
            </nb-option>
          </nb-select>
        </div>
      </div>
      <div class="form-row-group">
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.scope" | translate }}</label>
          <nb-select [(selected)]="scope" fullWidth>
            <nb-option *ngFor="let s of scopeOptions" [value]="s.value">
              {{ s.labelKey | translate }}
            </nb-option>
          </nb-select>
        </div>
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.language" | translate }}</label>
          <nb-select [(selected)]="language" fullWidth>
            <nb-option value="de">Deutsch</nb-option>
            <nb-option value="en">English</nb-option>
            <nb-option value="fr">Français</nb-option>
            <nb-option value="es">Español</nb-option>
          </nb-select>
        </div>
        <div class="form-row">
          <label>{{ "pages.dozent.exercises.maxScore" | translate }}</label>
          <input nbInput type="number" [(ngModel)]="maxScore" />
        </div>
      </div>
      <div class="form-row auto-processing-row">
        <div class="auto-processing-copy">
          <label>
            {{ "pages.dozent.exerciseEditor.autoProcessing" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              [nbTooltip]="'pages.dozent.exerciseEditor.autoProcessingTooltip' | translate"
            ></nb-icon>
          </label>
          <p>{{ "pages.dozent.exerciseEditor.autoProcessingHint" | translate }}</p>
        </div>
        <nb-toggle [(checked)]="autoProcessSubmissions"></nb-toggle>
      </div>
      <div class="form-row auto-processing-row">
        <div class="auto-processing-copy">
          <label>
            {{ "pages.dozent.exerciseEditor.chatPractice" | translate }}
            <nb-icon
              icon="question-mark-circle-outline"
              [nbTooltip]="'pages.dozent.exerciseEditor.chatPracticeTooltip' | translate"
            ></nb-icon>
          </label>
          <p>{{ "pages.dozent.exerciseEditor.chatPracticeHint" | translate }}</p>
        </div>
        <nb-toggle
          [checked]="chatPracticeEnabled"
          (checkedChange)="onToggleChatPractice($event)"
        ></nb-toggle>
      </div>
      <div class="form-row">
        <label>{{ "input.description.label" | translate }}</label>
        <textarea nbInput fullWidth [(ngModel)]="description" rows="2"
          placeholder="{{ 'pages.dozent.exerciseEditor.descriptionPlaceholder' | translate }}"
        ></textarea>
      </div>
      <div class="form-row">
        <label>{{ "pages.dozent.exerciseEditor.learningGoals" | translate }}</label>
        <textarea nbInput fullWidth [(ngModel)]="learningGoals" rows="2"
          placeholder="{{ 'pages.dozent.exerciseEditor.learningGoalsPlaceholder' | translate }}"
        ></textarea>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Multi-Question Format -->
  <ng-container>
    <div class="questions-header">
      <h3>{{ "pages.dozent.exerciseEditor.questions" | translate }}</h3>
      <span class="question-count">{{ questions.length }} {{ "pages.dozent.exerciseEditor.questionsCount" | translate }}</span>
    </div>

    <nb-card *ngFor="let q of questions; let qi = index" class="question-card">
      <!-- Question Header (always visible) -->
      <nb-card-header class="question-header" (click)="toggleQuestion(qi)">
        <div class="question-header-left">
          <nb-icon [icon]="q.expanded ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
          <span class="question-label">
            {{ q.problemStatement ? (q.problemStatement.length > 80 ? q.problemStatement.substring(0, 80) + '...' : q.problemStatement) : ('pages.dozent.exerciseEditor.questionN' | translate) + ' ' + (qi + 1) }}
          </span>
        </div>
        <div class="question-header-right">
          <span class="badge">{{ getExerciseTypeLabel(q.exerciseType) }}</span>
          <span class="badge">{{ q.points }} {{ "pages.dozent.exerciseEditor.pts" | translate }}</span>
          <button nbButton ghost size="tiny" (click)="moveQuestion(qi, 'up'); $event.stopPropagation()" [disabled]="qi === 0">
            <nb-icon icon="arrow-upward-outline"></nb-icon>
          </button>
          <button nbButton ghost size="tiny" (click)="moveQuestion(qi, 'down'); $event.stopPropagation()" [disabled]="qi === questions.length - 1">
            <nb-icon icon="arrow-downward-outline"></nb-icon>
          </button>
          <button nbButton ghost size="tiny" status="danger" (click)="removeQuestion(qi); $event.stopPropagation()">
            <nb-icon icon="trash-outline"></nb-icon>
          </button>
        </div>
      </nb-card-header>

      <!-- Question Body (expanded) -->
      <nb-card-body *ngIf="q.expanded">
        <!-- Problem Statement -->
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.problemStatement" | translate }}</label>
          <textarea nbInput fullWidth [(ngModel)]="q.problemStatement" rows="3"
            placeholder="{{ 'pages.dozent.exercises.taskPlaceholder' | translate }}"
          ></textarea>
        </div>

        <!-- Answer Section -->
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.answer" | translate }}</label>

          <!-- Multiple Choice / True-False -->
          <div *ngIf="isChoiceType(q.exerciseType)" class="answer-options">
            <div *ngFor="let opt of getQuestionAnswerOptions(q); let oi = index" class="answer-option">
              <nb-checkbox [(ngModel)]="opt.is_correct"></nb-checkbox>
              <input nbInput fullWidth [(ngModel)]="opt.text"
                placeholder="{{ 'pages.dozent.exerciseEditor.optionPlaceholder' | translate }} {{ oi + 1 }}"
              />
              <button *ngIf="q.exerciseType !== 'true-false'" nbButton ghost size="small" status="danger" (click)="removeQuestionOption(q, oi)">
                <nb-icon icon="close-outline"></nb-icon>
              </button>
            </div>
            <button *ngIf="q.exerciseType !== 'true-false'" nbButton ghost size="small" (click)="addQuestionOption(q)">
              <nb-icon icon="plus-outline"></nb-icon>
              {{ "pages.dozent.exerciseEditor.addOption" | translate }}
            </button>
          </div>

          <!-- Open Ended -->
          <div *ngIf="!isChoiceType(q.exerciseType) && q.exerciseType !== 'fill-in-blank'">
            <textarea nbInput fullWidth [(ngModel)]="q.answer" rows="3"
              placeholder="{{ 'pages.dozent.exerciseEditor.expectedAnswerPlaceholder' | translate }}"
            ></textarea>
          </div>

          <!-- Fill in the Blank -->
          <div *ngIf="q.exerciseType === 'fill-in-blank'" class="fill-blank">
            <div class="form-row">
              <label>{{ "pages.dozent.exerciseEditor.fillSentence" | translate }}</label>
              <textarea nbInput fullWidth [(ngModel)]="q.answer.sentence" rows="2"
                placeholder="{{ 'pages.dozent.exerciseEditor.fillSentencePlaceholder' | translate }}"
              ></textarea>
            </div>
            <div class="form-row">
              <label>{{ "pages.dozent.exerciseEditor.correctAnswers" | translate }}</label>
              <div *ngFor="let ans of getQuestionFillAnswers(q); let ai = index" class="fill-answer-row">
                <input nbInput fullWidth [ngModel]="ans" (ngModelChange)="updateFillAnswer(q, ai, $event)"
                  placeholder="{{ 'pages.dozent.exerciseEditor.blankAnswer' | translate }} {{ ai + 1 }}"
                />
                <button nbButton ghost size="small" status="danger" (click)="removeQuestionFillAnswer(q, ai)" *ngIf="getQuestionFillAnswers(q).length > 1">
                  <nb-icon icon="close-outline"></nb-icon>
                </button>
              </div>
              <button nbButton ghost size="small" (click)="addQuestionFillAnswer(q)">
                <nb-icon icon="plus-outline"></nb-icon>
                {{ "pages.dozent.exerciseEditor.addBlank" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- Hint -->
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.hint" | translate }}</label>
          <textarea nbInput fullWidth [(ngModel)]="q.hint" rows="2"
            placeholder="{{ 'pages.dozent.exerciseEditor.hintPlaceholder' | translate }}"
          ></textarea>
        </div>

        <!-- Explanation / Additional Content -->
        <div class="form-row">
          <label>{{ "pages.dozent.exerciseEditor.additionalContent" | translate }}</label>
          <textarea nbInput fullWidth [(ngModel)]="q.additionalContent" rows="2"
            placeholder="{{ 'pages.dozent.exerciseEditor.additionalContentPlaceholder' | translate }}"
          ></textarea>
        </div>

        <!-- Points + Type per question -->
        <div class="form-row-group">
          <div class="form-row">
            <label>{{ "pages.dozent.exerciseEditor.pts" | translate }}</label>
            <input nbInput type="number" [(ngModel)]="q.points" />
          </div>
          <div class="form-row">
            <label>{{ "pages.dozent.exercises.type" | translate }}</label>
            <nb-select [(selected)]="q.exerciseType" fullWidth>
              <nb-option *ngFor="let type of exerciseTypes" [value]="type.value">
                {{ type.label }}
              </nb-option>
            </nb-select>
          </div>
        </div>
      </nb-card-body>
    </nb-card>

    <!-- Add Question Button -->
    <button nbButton fullWidth appearance="outline" (click)="addQuestion()">
      <nb-icon icon="plus-outline"></nb-icon>
      {{ "pages.dozent.exerciseEditor.addQuestion" | translate }}
    </button>
  </ng-container>

</div>
